import React, { FC, useState } from 'react'
import DropDownButton from '../../../../../../Components/dropdown-button/DropDownButton'
import { pageToggleCall, pageToggleMyOffice, pageToggleTheirOffice } from '../../../../../../store/pages-management/actions'
import { useDispatch } from 'react-redux'
import { LocationProps as Props } from './types'
import Call from './Locations/Call'
import MyOffice from './Locations/MyOffice'
import TheirOffice from './Locations/TheirOffice'
import 'font-awesome/css/font-awesome.css'

const Location: FC<Props> = ({ strings, location }) => {
  // REDUX STORE
  const dispatch = useDispatch()

  // State
  const [ selectedLocationTab, setSelectedLocationTab ] = useState('MY_OFFICE')

  /**
   * Handles the "call" click by toggling it in the store
   */
  const toggleCall = () => dispatch(pageToggleCall())

  /**
   * Handles the "my office" click by toggling it in the store
   */
  const toggleMyOffice = () => dispatch(pageToggleMyOffice())

  /**
   * Handles the "their office" click by toggling it in the store
   */
  const toggleTheirOffice = () => dispatch(pageToggleTheirOffice())

  return (
    <div className="part locations">
      <div className="part_header">
        <h3 className="inline">Location</h3>
        { !(location?.my_office?.enabled && location?.call?.enabled && location?.their_office?.enabled) &&
        <DropDownButton className="inline float-right">
          <div>
            <i className="fa fa-plus" />
            { ' ' + strings.add_location }
          </div>
          <div>
            { !location?.my_office?.enabled &&
              <button className="button" onClick={ () => toggleMyOffice() }>
                { strings.my_office }
              </button>
            }

            { !location?.call?.enabled &&
              <button className="button" onClick={ () => toggleCall() }>
                { strings.call }
              </button>
            }

            { !location?.their_office?.enabled &&
              <button className="button" onClick={ () => toggleTheirOffice() }>
                { strings.their_office }
              </button>
            }
          </div>
        </DropDownButton>
        }
      </div>

      <div>
        <ul className="tab_nav green">
          { location?.my_office?.enabled &&
            <li
              className={ selectedLocationTab === 'MY_OFFICE' ? 'selected' : '' }
              onClick={ () => setSelectedLocationTab('MY_OFFICE') }
              role="presentation"
            >
              { strings.my_office }
              { (location?.call?.enabled || location?.their_office?.enabled) &&
                <i
                  className="fa fa-times"
                  style={{ marginLeft: '10px' }}
                  onClick={ () => toggleMyOffice() }
                  role="presentation"
                />
              }
            </li>
          }

          { location?.call?.enabled &&
            <li
              className={ selectedLocationTab === 'CALL' ? 'selected' : '' }
              onClick={ () => setSelectedLocationTab('CALL') }
              role="presentation"
            >
              { strings.call }
              { (location?.my_office?.enabled || location?.their_office?.enabled) &&
                <i
                  className="fa fa-times"
                  style={{ marginLeft: '10px' }}
                  onClick={ () => toggleCall() }
                  role="presentation"
                />
              }
            </li>
          }

          { location?.their_office?.enabled &&
            <li
              className={ selectedLocationTab === 'THEIR_OFFICE' ? 'selected' : '' }
              onClick={ () => setSelectedLocationTab('THEIR_OFFICE') }
              role="presentation"
            >
              { strings.their_office }
              { (location?.my_office?.enabled || location?.call?.enabled) &&
                <i
                  className="fa fa-times"
                  style={{ marginLeft: '10px' }}
                  onClick={() => toggleTheirOffice()}
                  role="presentation"
                />
              }
            </li>
          }
        </ul>
      </div>

      {/* RENDER 'MY OFFICE' IF NECESSARY */}
      { location?.my_office?.enabled && selectedLocationTab === 'MY_OFFICE' &&
      <MyOffice strings={ strings } location={ location } />
      }

      {/* RENDER 'CALL' IF NECESSARY */}
      { location?.call?.enabled && selectedLocationTab === 'CALL' &&
      <Call strings={ strings } location={ location } />
      }

      {/* RENDER 'THEIR OFFICE' IF NECESSARY */}
      { location?.their_office?.enabled && selectedLocationTab === 'THEIR_OFFICE' &&
      <TheirOffice strings={ strings } />
      }
    </div>
  )
}

export default Location